<template>
<div class="bg">
<!--  <div class="nav">
    <a class="btn btn-back" href="javascript:history.back()">« 返回下载页</a>
    <a class="btn btn-down" href="./ios.mobileconfig">点击下载APP</a>
  </div>-->
  <div class="nav">
    <a class="btn btn-back" href="javascript:history.back()">« 返回下载页</a>
    <a class="btn btn-down" :href="downLink">点击下载APP</a>
  </div>
  <div class="hr"></div>
  <div class="install-step">
    <div class="step">
      <h3>STEP 1：点击下载，允许描述文件</h3>
      <img referrerpolicy="no-referrer" src="../assets/images/1.jpg">
    </div>
    <div class="hr"></div>
    <div class="step">
      <h3>STEP 2 打开 设置- 通用-vpn与设备管理-配置描述文件</h3>
      <img referrerpolicy="no-referrer" src="../assets/images/2.jpg">
    </div>
    <div class="hr"></div>
    <div class="step">
      <h3>STEP 3：安装描述文件</h3>
      <img referrerpolicy="no-referrer" src="../assets/images/3.jpg">
    </div>
    <div class="hr"></div>
    <div class="step">
      <h3>STEP 4：输入锁屏密码安装</h3>
      <img referrerpolicy="no-referrer" src="../assets/images/4.jpg">
    </div>
    <div class="hr"></div>
    <div class="step">
      <h3>STEP 5：安装描述文件</h3>
      <img referrerpolicy="no-referrer" src="../assets/images/5.jpg">
    </div>
    <div class="hr"></div>
    <div class="step">
      <h3>STEP 6：恭喜你，安装成功！回到桌面打开！</h3>
      <img referrerpolicy="no-referrer" src="../assets/images/6.jpg">
    </div><br><br><br>
  </div>
</div>
</template>

<script>
export default {
  name: "Help",
  data() {
    return {
      downLink: '',
    };
  },
  mounted: function () {
    // -------- check device is pc or mobile ----------
    // ----------- check android or apple device ----------
    var ua = window.navigator.userAgent.toLowerCase();
    var Sys = {};
    var s;
    (s = ua.match(/version\/([\d.]+).*safari/)) ? (Sys.safari = s[1]) : 0;
    if (/(iPhone|iPad|iPod|iOS)/i.test(ua)) {
      // $(".down").click(function (event) {
      //   $(".down").attr("href", window.__env.iosDownloadLink);
      // });
      this.downLink = window.__env.iosDownloadLink;
      console.log(this.downLink)
      this.provisionLink = window.__env.iosMobileProvision;
    }
    if (/(Android)/i.test(ua)) {
      // $(".down").attr("href", window.__env.androidDownloadLink);
      this.downLink = window.__env.androidDownloadLink;
    }

    this.title = window.__env.title;
    this.logo = window.__env.logo;
    this.version = window.__env.version;
  },
}
</script>

<style scoped>
.bg{
  background-color:#323232;
  font-size: medium;
}
body,div,dl,dt,dd,ul,ol,li,h1,h2,h3,h4,h5,h6,pre,code,form,fieldset,legend,input,textarea,p,blockquote,th,td,header,hgroup,nav,section,article,aside,footer,figure,figcaption,menu{margin:0;padding:0}h1,h2,h3,h4,h5,h6{font-weight:normal}body{font-family:Helvetica,"Microsoft YaHei";line-height:28px;font-size:14px;color:#000;-webkit-user-select:none;-webkit-text-size-adjust:none}
.install-step{padding: 0 15px;text-align: center;}
.step img{max-width: 70%; border-radius: 3%;}
h3{padding: 15px 0;text-align: center;font-weight: ;color: #fff;font-size: 18px;}
.hr{border-bottom:1px solid #efefef2b;margin: 20px 0;}
.btn{display: inline-block;padding: 5px 39px;margin-top: 20px;text-decoration: none;border-radius: 6px;margin-left: 15px;}
.btn.btn-back {color: #004085;background-color: #cce5ff;border-color: #b8daff;}
.btn.btn-down{color: #155724;background-color: #d4edda;border-color: #c3e6cb;}
@media (min-width: 576px) {
  h3{text-align: center;font-size: 20px;padding: 20px 0;}
  .nav{text-align: center;}
}
</style>



// WEBPACK FOOTER //
// src/components/Help.vue